import React from "react";
import { Award, Compass, GraduationCap, Moon } from "lucide-react";

const BADGES = {
  team_pick: { icon: Award, cls: "bg-violet-100 text-violet-800 border-violet-200", label: { fr: "Sélection de l'équipe", en: "Team pick", es: "Selección del equipo" } },
  good_first_visit: { icon: Compass, cls: "bg-blue-100 text-blue-800 border-blue-200", label: { fr: "Bon pour une première visite", en: "Great for a first visit", es: "Ideal primera visita" } },
  popular_students: { icon: GraduationCap, cls: "bg-emerald-100 text-emerald-800 border-emerald-200", label: { fr: "Populaire chez les étudiants", en: "Popular with students", es: "Popular entre estudiantes" } },
  ideal_evening: { icon: Moon, cls: "bg-amber-100 text-amber-800 border-amber-200", label: { fr: "Idéal en soirée", en: "Ideal in the evening", es: "Ideal por la noche" } },
};

export default function TrustBadges({ place, lang }) {
  const active = Object.keys(BADGES).filter((k) => place[k]);
  if (!active.length) return null;
  return (
    <div className="flex flex-wrap gap-2" data-testid="trust-badges">
      {active.map((k) => {
        const b = BADGES[k];
        const Icon = b.icon;
        return (
          <span key={k} className={`inline-flex items-center gap-1.5 rounded-full border px-3 py-1 text-xs font-semibold ${b.cls}`}>
            <Icon className="h-3.5 w-3.5" /> {b.label[lang] || b.label.fr}
          </span>
        );
      })}
    </div>
  );
}
